module.exports = __webpack_public_path__ + "img/bag.0700a4d4.png";